export const decodeBase64Svg = (base64String: string): string => atob(base64String.split(",")[1]);

export const trimAndResizeSignature = (base64Svg: string, maxWidth?: number, maxHeight?: number): string => {
    const svgString = decodeBase64Svg(base64Svg);
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgString, "image/svg+xml");
    const svg = doc.documentElement;
    const paths = Array.from(svg.querySelectorAll("path"));

    if (paths.length === 0) {
        return base64Svg;
    }

    const tempSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    tempSvg.setAttribute("style", "position: absolute; visibility: hidden;");
    document.body.appendChild(tempSvg);

    try {
        paths.forEach((path) => {
            tempSvg.appendChild(path.cloneNode(true));
        });

        const bbox = tempSvg.getBBox();

        const ratio = Math.min((maxWidth ?? bbox.width) / bbox.width, (maxHeight ?? bbox.height) / bbox.height, 1);
        const finalWidth = bbox.width * ratio;
        const finalHeight = bbox.height * ratio;

        svg.setAttribute("viewBox", `${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}`);
        svg.setAttribute("width", finalWidth.toString());
        svg.setAttribute("height", finalHeight.toString());

        svg.removeAttribute("transform");

        const serializer = new XMLSerializer();
        const processedSvgString = serializer.serializeToString(svg);

        return `data:image/svg+xml;base64,${btoa(processedSvgString)}`;
    } catch (e) {
        console.error("Error processing SVG:", e);
        return base64Svg;
    } finally {
        document.body.removeChild(tempSvg);
    }
};
